import { teamsCollection, teamUsersCollection } from '@/firebase';
import moment from 'moment';

export default class TeamsService {
  static async fetchCompanyTeams(companyId) {
    const teams = [];
    const snapshot = await teamsCollection
      .where('company_id', '==', companyId)
      .orderBy('title')
      .get();

    snapshot.forEach((doc) => teams.push(doc.data()));

    return teams;
  }

  static async fetchTeamBySlug({ companyId, slug }) {
    let team;

    const snapshot = await teamsCollection
      .where('company_id', '==', companyId)
      .where('slug', '==', slug)
      .get();

    snapshot.forEach((doc) => {
      team = {
        uid: doc.id,
        ...doc.data(),
      };
    });

    return team;
  }

  static async fetchTeamMembers(teamId) {
    const teamMembers = [];
    const snapshot = await teamUsersCollection
      .where('team_id', '==', teamId)
      .get();

    snapshot.forEach((doc) => teamMembers.push({
      uid: doc.id,
      ...doc.data(),
    }));

    return teamMembers;
  }

  static async createTeam(data) {
    const seconds = moment().unix();

    const doc = await teamsCollection.doc();

    doc.set({
      company_id: data.companyId,
      title: data.title,
      description: data.description,
      leader_id: data.leaderId,
      slug: data.slug,
      created_at: { seconds },
    });

    return doc.id;
  }

  static async updateTeamInfo(teamId, data) {
    const seconds = moment().unix();

    await teamsCollection
      .doc(teamId)
      .update({
        title: data.title,
        description: data.description,
        leader_id: data.leaderId,
        slug: data.slug,
        updated_at: { seconds },
      });

    const members = await TeamsService.fetchTeamMembers(teamId);
    const removedMembers = members.filter((member) => data.members.indexOf(member.user_id) === -1);

    return Promise.all([
      ...data.members.map((member) => {
        if (!members.find((item) => item.user_id === member)) {
          return teamUsersCollection.doc().set({
            team_id: teamId,
            user_id: member,
          });
        }

        return Promise.resolve();
      }),
      ...removedMembers.map((member) => teamUsersCollection.doc(member.uid).delete()),
    ]);
  }

  static async addTeamMember(teamId, data) {
    return teamsCollection.doc(teamId).set(data);
  }

  static async removeTeamMember() {
    return true;
  }
}
